import React, { PropsWithChildren } from 'react';
import {
  Takeover,
  TakeoverContent,
  TakeoverFooter,
  TakeoverHeader
} from '../../atoms/takeover-modal/TakeoverModal';
import styles from './full-screen-modal.module.scss';
import { Button } from '../../atoms/button/Button';
import { GHubTheme, useGetTheme } from '../../../modules/theme';
import Icon, { ICONS_ENUM } from '@sanlamcx/dsm-icons';

type FullScreenModalButtonProps = {
  text: string;
  onClick: () => void;
};

type FullScreenModalProps = {
  isOpen: boolean;
  onClose: () => void;
  logo?: React.ReactNode;
  primaryButton?: FullScreenModalButtonProps;
  statementType?: string;
};

export const FullScreenModal = ({
  isOpen,
  onClose,
  logo,
  primaryButton,
  statementType,
  children
}: PropsWithChildren<FullScreenModalProps>) => {
  const theme = useGetTheme();
  return (
    <Takeover open={isOpen} onClose={onClose} className={styles.modal} animated>
      <TakeoverHeader
        hasLogo={false}
        onClose={onClose}
        title={logo}
        className={styles.closeButton}
      />
      <TakeoverContent containerClassName={styles.content}>
        {children}
        <div className={styles.contentSpacer} />
      </TakeoverContent>
      <TakeoverFooter
        primaryButton={
          primaryButton ? (
            <GHubTheme theme={theme} variant='secondary'>
              <Button
                datatest-id={`${statementType}DownloadExcelButton`}
                startIcon={<Icon icon={ICONS_ENUM.DOCUMENTS_EXCEL_DOCUMENT} />}
                onClick={primaryButton.onClick}
                variant={Button.VARIANT.PRIMARY}
              >
                {primaryButton.text}
              </Button>
            </GHubTheme>
          ) : null
        }
        secondaryButton={
          <GHubTheme theme={theme} variant='secondary'>
            <Button onClick={onClose} variant={Button.VARIANT.SECONDARY}>
              Close
            </Button>
          </GHubTheme>
        }
      />
    </Takeover>
  );
};
